var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.7,14.7V9.8C17.5,8.7,18,7.4,18,6c0-3.3-2.7-6-6-6C8.7,0,6,2.7,6,6c0,1.4,0.5,2.7,1.3,3.8v4.9H2v6.7h1.3 V24h17.3v-2.7H22v-6.7H16.7z M12,1.5c2.5,0,4.5,2,4.5,4.5c0,1-0.3,2-1,2.8l-0.3,0.4v0.5v4.7H8.9V9.8V9.2L8.5,8.8C7.9,8,7.5,7,7.5,6 C7.5,3.5,9.5,1.5,12,1.5z M19.1,22.5H4.9v-1h14.3V22.5z M20.5,19.8h-17v-3.6h17V19.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/stamp.b11e65a2ca34132d0be24a64d7f25178.svg";
export { ForwardRef as ReactComponent };